import { AppliedBillableConceptResponse } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { StrictNullable } from '@/shared/types/app.types'
import { BillingModalDeliveryNotesAddToGridDatasource } from '@/modules/billing-module/components/modal/delivery-notes/add-to/config/billing-modal-delivery-notes-add-to-grid.datasource'

export interface BillingModalDeliveryNotesAddToParams {
    appliedBillableConcepts: AppliedBillableConceptResponse[]
}

export interface BillingModalDeliveryNotesAddToState {
    datasource: StrictNullable<BillingModalDeliveryNotesAddToGridDatasource>
}
export const initialBillingModalDeliveryNotesAddToState =
    (): BillingModalDeliveryNotesAddToState => ({
        datasource: null
    })
